import { useState } from 'react';
import { toast } from 'sonner';
import { ROLE_LABELS } from '@bp/shared';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { Button, Card, CardHeader, ErrorNote, Field, Input, PageHeader } from '@/components/ui';

export function AccountPage() {
  const { me } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);
  return (
    <>
      <PageHeader title="Your account" subtitle={`${me?.email} · ${me && ROLE_LABELS[me.role]}`} />
      <Card className="max-w-md">
        <CardHeader title="Change password" subtitle="Signs you out on every other device." />
        <form className="space-y-4 p-4" onSubmit={async (e) => {
          e.preventDefault();
          setBusy(true);
          setError(null);
          try {
            await api.post('/api/auth/password/change', { current_password: current, new_password: next });
            toast.success('Password changed.');
            setCurrent('');
            setNext('');
          } catch (err) { setError(err); } finally { setBusy(false); }
        }}>
          <Field label="Current password"><Input type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} required /></Field>
          <Field label="New password" hint="At least 10 characters."><Input type="password" autoComplete="new-password" minLength={10} value={next} onChange={(e) => setNext(e.target.value)} required /></Field>
          <ErrorNote error={error} />
          <Button type="submit" loading={busy}>Change password</Button>
        </form>
      </Card>
    </>
  );
}
